"use strict";

var LoggerInstance = require("js-logger").get("ProjectActions");

var ProjectConstants = require("./ProjectConstants");
var ProjectStore = require("./ProjectStore");

var PledgeStatementHelper = require("../accountComponents/PledgeStatementHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");
var CheckoutConstants = require("../checkoutComponents/CheckoutConstants");
var DonationUpsellHelper = require("../checkoutComponents/DonationUpsellHelper");
var PaymentTermsHelper = require("../checkoutComponents/PaymentTermsHelper");

var Spinner = require("../client/Spinner");

var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var ProjectActions = {
	setGiftAmount: function(selectedAmount, tangibleCode, context) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_GIFT_AMOUNT,
			selectedAmount,
			tangibleCode,
			context
		});

		this._setRecurringSummaryData();

		this._updateIsCheckoutDispatcher(context, {
			actionType: CheckoutConstants.CART_UPDATE_DONATION_AMOUNT_OPCO,
			selectedAmount,
			tangibleCode,
			context
		});

		DonationUpsellHelper.handleDonationUpsellChange();
	},

	setMinimumAmount: function(minimumAmount, tangibleCode, context) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_MINIMUM_AMOUNT,
			minimumAmount,
			tangibleCode,
			context
		});
	},

	setSubaccountAmount: function(subaccountCode, amount) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_SUBACCOUNT_GIFT_AMOUNT,
			amount,
			subaccountCode
		});

		this._setRecurringSummaryData();

		this._updateIsCheckoutDispatcher(/*context*/null, {
			actionType: CheckoutConstants.SET_SUBACCOUNT_GIFT_AMOUNT_OPCO,
			amount,
			subaccountCode
		});

		DonationUpsellHelper.handleDonationUpsellChange();
	},

	setFrequency: function(selectedFrequency, tangibleCode, context) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_DONATION_FREQUENCY,
			selectedFrequency,
			tangibleCode,
			context
		});

		if (selectedFrequency !== "O" && ProjectStore.getIsChargeTodayRequired()) {
			this.setUpsell(true);
		}

		this._setRecurringSummaryData();

		this.triggerTotalChangedHandler();

		this._updateIsCheckoutDispatcher(context, {
			actionType: CheckoutConstants.CART_UPDATE_DONATION_FREQUENCY_OPCO,
			donationFrequency: ProjectStore.getSelectedFrequency()
		});

		this._updateIsChargeTodayInCheckoutStore(context);
	},

	setDonationPremium: function(selectedPremium, tangibleCode) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_DONATION_PREMIUM,
			selectedPremium,
			tangibleCode
		});
	},

	setUseOnDay: function(selectedUseOnDay, tangibleCode, pledgeCode, context) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_USE_ON_DAY,
			selectedUseOnDay,
			tangibleCode,
			pledgeCode,
			context
		});

		this._updateIsChargeTodayInCheckoutStore(context);
	},

	setUpsell: function(upsell, tangibleCode, pledgeCode, context) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_UPSELL,
			upsell,
			tangibleCode,
			pledgeCode,
			context
		});

		this._updateIsChargeTodayInCheckoutStore(context);
	},

	setAnonymous: function(isAnonymous) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.SET_ANONYMOUS,
			isAnonymous
		});
	},

	initializeStore: function(options) {
		Dispatcher.dispatch({
			actionType: ProjectConstants.INITIALIZE,
			options: options
		});
	},

	initializeProjects: function(options) {
		options = options || {};
		var that = this; // Parent context, don't want to change the this context because jQuery uses it.
		document.addEventListener("DOMContentLoaded", function(event) {
			var project = ProjectStore.get("project");
			var projectCode = project && project.ProjectCode;
			var isSecure = ProjectStore.getIsSecure();

			if (isSecure) {
				projectCode = "secure-project"
			}

			var $projectPremiums = $("[data-component='projectPremiums']");
			var $projectPremiumsRadios = $projectPremiums.find("[data-component='projectPremiumsRadio']");
			var getPremiumFromRadio = function(selectedPremium) {
				var $selectedPremium = $(selectedPremium);
				var $parent = $selectedPremium.parent();
				var premium;

				if ($parent.is("[data-component='projectPremiums.optOut']")) {
					premium = null;
					// Don't show the ship-to address component if the constituent opts-out of the premium (for OPC)
					$("[data-component='shipTo']").hide();
				} else {
					// Cannot use $selectedPremium.siblings() here because the radio buttons are not siblings. We have to go up to the parent projectPremium
					// and then find all the descendant radio buttons to determine which radio this is so we can get the correct premium product code.
					var radioIndex = $selectedPremium.parents("[data-component='projectPremiums']").first().find("[data-component='projectPremiumsRadio']").index($selectedPremium);

					if (radioIndex > -1 && project && project["Premiums"] && project["Premiums"][radioIndex]) {
						premium = project["Premiums"][radioIndex]["ProductCode"];
					} else {
						LoggerInstance.error(`Unable to locate the requested premium for projectPremiumRadio index: ${radioIndex}.`);
						premium = null;
					}

					if (premium) {
						// Show the ship-to address component if the constituent is choosing to receive the premium (for OPC)
						$("[data-component='shipTo']").show();
					}
				}

				return premium;
			};
			var handleChangePremium = function(event) {
				var $selectedPremium = $(event.target);
				var premium = getPremiumFromRadio($selectedPremium);

				if ($selectedPremium.prop("checked") && project) {
					ProjectActions.setDonationPremium(premium, project["ProjectCode"]);
					that._checkoutDispatcher.dispatch({
						actionType: CheckoutConstants.VALIDATE_PAYPAL_CHECKOUT
					});
				}

				var isUpsellBeforePremiumSelectionKey = `${project["ProjectCode"]}_isUpsellBeforePremiumSelection`;

				if (ProjectStore.getIsChargeTodayRequiredOnlyWithPremium()) {
					if (premium) {
						if (sessionStorage.getItem(isUpsellBeforePremiumSelectionKey) === null) {
							sessionStorage.setItem(isUpsellBeforePremiumSelectionKey, JSON.stringify({ isUpsellChecked: ProjectStore.getSelectedUpsell() }));
						}

						ProjectActions.setUpsell(true);
					} else {
						var wasUpsellChecked = (JSON.parse(sessionStorage.getItem(isUpsellBeforePremiumSelectionKey)) || {}).isUpsellChecked;
						ProjectActions.setUpsell(Boolean(wasUpsellChecked));
						sessionStorage.removeItem(isUpsellBeforePremiumSelectionKey);
					}
				}
			};

			if ($projectPremiumsRadios.length > 0) {
				$projectPremiumsRadios.click(handleChangePremium);
			}

			if ($projectPremiums.length > 0) {
				$projectPremiums.each(function(index, premium) {
					var defaultOptOut = premium.getAttribute("data-default-opt-out");
					var defaultRadio;

					if (defaultOptOut) {
						defaultRadio = premium.querySelectorAll("[data-component='projectPremiums.optOut'] [data-component='projectPremiumsRadio']");
					} else {
						defaultRadio = premium.querySelectorAll("[data-component='projectPremiums.premium'] [data-component='projectPremiumsRadio']");
					}
					if (defaultRadio.length > 0) {
						defaultRadio[0].checked = true;
						var premium = getPremiumFromRadio(defaultRadio[0]);

						if (project) {
							ProjectActions.setDonationPremium(premium, project["ProjectCode"]);
						}
					}
				});
			}

			if (project || isSecure) {
				// Initialize cached values and remove from session storage
				var cachedValues = JSON.parse(sessionStorage.getItem(projectCode));
				if (cachedValues) {
					sessionStorage.removeItem(projectCode);

					if (cachedValues.startDate) {
						$("[data-component='recurringStartDateDropdown.selector']")
							.filter((index, item) => $(item).closest("[data-component='searchResults'],[data-component='category']").length === 0)
							.first()
							.val(cachedValues.startDate);

						Dispatcher.dispatch({
							actionType: ProjectConstants.SET_RECURRING_START_DATE,
							selectedStartDate: cachedValues.startDate
						});

						that._updateIsChargeTodayInCheckoutStore();
					}

					if (cachedValues.isRecurringUpsell) {
						_.defer(() => {
							ProjectActions.setUpsell(true);
						});
					}

					if (cachedValues.isDonationUpsellChecked) {
						_.defer(() => {
							DonationUpsellHelper.checkDonationUpsell();
						});
					} else if (cachedValues.isDonationUpsellChecked === false) {
						_.defer(() => {
							DonationUpsellHelper.uncheckDonationUpsell();
						});
					}

					if (cachedValues.premium) {
						_.defer(() => {
							ProjectActions.setDonationPremium(cachedValues.premium, projectCode);
						});
					}

					if (cachedValues.subaccounts) {
						Object.keys(cachedValues.subaccounts).forEach(key => {
							that.setSubaccountAmount(key, cachedValues.subaccounts[key]);
						});
					}

					if (cachedValues.projectNote) {
						$("[data-component='collapsorProjectNote.collapsor.input']")
							.prop("checked", true)
							.trigger("change");

						$("[data-component='collapsorProjectNote.input']")
							.val(cachedValues.projectNote);
					}

					if (cachedValues.secureMatchingText) {
						$("[data-component='textInput'] input[name='secureInput']")
							.first()
							.val(cachedValues.secureMatchingText);
					}

					if (cachedValues.pledgeId) {
						ProjectStore.setPledgeId(cachedValues.pledgeId);
					}

					if (cachedValues.relatedAccount) {
						ProjectStore.setRelatedAccount(cachedValues.relatedAccount);
					}
				}

				// add onUnload event for caching selected values ONLY on project detail/landing pages.
				$(window).off("unload.cacheProjectValues");
				$(window).on("unload.cacheProjectValues", (event) => {
					if (window.CHECKOUT_COMPLETED) {
						return;
					}

					var isOtherSelected = $(".giftAmount.selected")
						.filter((i, item) => $(item).closest("[data-component='searchResults'],[data-component='category']").length === 0)
						.hasClass("giftAmountOther");
					var startDate = $("[data-component='recurringStartDateDropdown.selector']")
						.filter((index, item) => $(item).closest("[data-component='searchResults'],[data-component='category']").length === 0)
						.first()
						.val();
					var secureMatchingText = $("[data-component='textInput'] input[name='secureInput']")
						.first()
						.val();
					var isRecurringUpsell = $("input#recurringUpsellCheckbox").prop("checked");
					var isDonationUpsellChecked = DonationUpsellHelper.hasDonationUpsell();
					var value = {
						amount: ProjectStore.getSelectedAmount(),
						frequency: ProjectStore.getSelectedFrequency(),
						isDonationUpsellChecked,
						isOtherSelected,
						isRecurringUpsell,
						pledgeId: ProjectStore.getPledgeId(),
						premium: ProjectStore.getSelectedPremium(),
						relatedAccount: ProjectStore.getRelatedAccount(),
						secureMatchingText: secureMatchingText,
						startDate,
						subaccounts: ProjectStore.getSubaccountAmounts(),
						useOnDay: ProjectStore.getSelectedUseOnDay()
					};

					if ($("[data-component='collapsorProjectNote']").length) {
						var collapsorChecked = $("[data-component='collapsorProjectNote.collapsor.input']")
							.prop("checked");
						var $collapsorNote = $("[data-component='collapsorProjectNote.input']");

						if (collapsorChecked && $collapsorNote.val()) {
							value.projectNote = $collapsorNote.val();
						}
					}
					sessionStorage.setItem(projectCode, JSON.stringify(value));
				});
			}

			that._setRecurringSummaryData();
		});
		ProjectActions.initializeStore(options);
	},

	getCachedValues() {
		var project = ProjectStore.get("project");
		var projectCode = project && project.ProjectCode;

		var isSecure = ProjectStore.getIsSecure();

		if (isSecure) {
			projectCode = "secure-project";
		}

		var cachedData;
		if (project || isSecure) {
			cachedData = JSON.parse(sessionStorage.getItem(projectCode));
		}

		return cachedData || { };
	},

	addToCart: function(event, context, tangibleCode, successCallback) {
		event = ProjectActions._getEventOrReturn(event, "Add To Cart called successfully.", /*preventDefaultInDesignMode*/false);
		if (!event) {
			return;
		}

		var isInPledgeStatementSession = ProjectStore.get("isInPledgeStatementSession");
		var pledgeStatementEntryWizard = ProjectStore.get(WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY);

		PledgeStatementHelper.confirmAbandonPledgeStatementSession(isInPledgeStatementSession, pledgeStatementEntryWizard).done(() => {
			try {

				Spinner.showSpinner();
				var components = [];
				if (context) {
					var $parent = $(event.target).closest("[data-component='searchResults.project'],[data-component='category.project'],[data-component='carousel.project']");
					components = [$parent.find("[data-has-custom-validator='true']")];
				} else {
					//Validate any array that is not within a searchResults, category, or carousel component
					var componentsToAdd = "[data-react-component-name='ButtonGiftArray'],[data-react-component-name='RadioGiftArray'],[data-react-component-name='SelectGiftArray']";
					componentsToAdd += ",[data-component='buttonGiftAmount'],[data-component='radioGiftAmount'],[data-component='selectGiftAmount']";

					var $elements = $(componentsToAdd).filter((index, element) => {
						var $element = $(element);
						return $element.parents().length == $element.parents().not("[data-component='searchResults.project'],[data-component='category.project'],[data-component='carousel.project']").length;
					});
					components = [$elements];
				}

				ValidationHelper.validate({ components }).always(isValid => {
					if (!isValid) {
						Spinner.removeSpinner();
						return;
					}

					this._shouldShowPaymentTerms().done((shouldShowPaymentTerms) => {
						if (shouldShowPaymentTerms) {
							var deferred = new $.Deferred();
							var project = ProjectStore.get("project");
							var paymentTermsText = project.PaymentTermsText;

							PaymentTermsHelper.showPaymentTermsModal(deferred, project, Constants.PAYMENT_TERMS_TYPES.ADD_TO_CART);
							deferred.done((doesAgreeToTerms) => {
								if (doesAgreeToTerms) {
									this._continueAddToCart(context, tangibleCode, successCallback, paymentTermsText);
								} else {
									Spinner.removeSpinner();
								}
							}).fail(() => {
								Spinner.removeSpinner();
							});
						} else {
							// Not showing payment terms
							this._continueAddToCart(context, tangibleCode, successCallback);
						}
					}).fail(() => {
						// In theory, this should not happen
						LoggerInstance.warn("Some issue happening while checking to see if we need to show payment terms.  Just continue adding to cart.");
						this._continueAddToCart(context, tangibleCode, successCallback);
					});
				});
			} catch (exception) {
				LoggerInstance.error(exception);
			} finally {
				return false;
			}
		});
	},

	_continueAddToCart: function (context, tangibleCode, successCallback, paymentTermsText) {
		var shoppingCartData = ProjectActions.getShoppingCartData({ context, tangibleCode, paymentTermsText });
		CheckoutApi.addToCart(shoppingCartData).done((addToCartResponse) => {
			LoggerInstance.debug(addToCartResponse);

			if (addToCartResponse.success) {
				if (typeof successCallback === "function") {
					successCallback();
					Spinner.removeSpinner();
				} else {
					window.location = "/shoppingcart";
				}
			} else {
				BootstrapPrompt.alert(ProjectStore.getWizardValue(
					WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
					WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
					{ tangibleType: "donation" }
				));
			}
		}).fail(() => {
			BootstrapPrompt.alert(ProjectStore.getWizardValue(
				WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
				WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
				{ tangibleType: "donation" }
			));
			Spinner.removeSpinner();
		});
	},

	getShoppingCartData: function(cartDataOptions) {
		cartDataOptions = cartDataOptions || {};

		var donationInformation = ProjectStore.getDonationInformation(cartDataOptions);
		var {
			project,
			amount,
			subaccountAmounts,
			frequency,
			anonymous,
			useOnDay,
			upsell,
			isRecurring,
			pledgeId,
			premium,
			relatedAccount,
			startDate,
			minimumDonationAmount
		} = donationInformation;
		var projectNote = $('input[name=projectNote]').val() || undefined;

		//Creating cartItems to in SE shopping cart
		var cartItems = {
			donations: []
		};
		if (amount && Number(amount)) {
			//The amount might be zero if we are hiding the gift array when showing subaccounts.
			var donation = {
				amount,
				anonymous,
				customerChoseChargeToday: upsell,
				deductible: true,
				frequency,
				isRecurring,
				pledgeId,
				premium,
				project,
				relatedAccount,
				shortComment: projectNote,
				startDate,
				useOnDay,
				minimumDonationAmount
			};
			if (cartDataOptions.paymentTermsText) {
				donation.acceptedPaymentTermsText = cartDataOptions.paymentTermsText;
			}

			cartItems.donations.push(donation);
		}

		if (subaccountAmounts) {
			var startDate = ProjectStore.getSelectedStartDate();
			cartItems.donations = cartItems.donations.concat(_.map(subaccountAmounts, (subaccountAmount, subaccount) => {
				if (subaccountAmount <= 0) {
					return null;
				}
				var subaccount = {
					project,
					subaccount,
					amount: subaccountAmount,
					frequency,
					isRecurring,
					anonymous,
					customerChoseChargeToday: upsell,
					useOnDay: frequency !== "O" ? useOnDay : null,
					deductible: true,
					shortComment: projectNote,
					startDate,
					minimumDonationAmount
				};
				if (cartDataOptions.paymentTermsText) {
					subaccount.acceptedPaymentTermsText = cartDataOptions.paymentTermsText;
				}
				return subaccount;
			}).filter(donation => !!donation));
		}
		return { project, cartItems };
	},

	getMonthFromWizard: function(monthString, wizard) {
		var monthFromWizard = wizard[`${monthString.toLowerCase()}Display`];
		return monthFromWizard || monthString;
	},

	initializeCartRecurringStartDateDropdowns: function ($carts) {
		$carts.each((cartIndex, cart) => {
			var isSaveForLaterCart = cart.getAttribute("data-cart-type") === "saveForLater";
			var donations = isSaveForLaterCart ? window.CheckoutActions.getSaveForLaterCartDonations() : window.CheckoutActions.getCartDonations();

			$(cart).find("[data-component='cart.populated.project'] [data-component='recurringStartDateDropdown']").each((dropdownIndex, dropdown) => {
				var $dropdownComponent = $(dropdown);
				var $dropdownSelector = $dropdownComponent.find("select");
				var projectId = $dropdownComponent.attr("data-donation-id");
				var donation = donations.find(donation => donation.id === projectId);

				// get value from cart
				if (!donation || donation.frequency === "O") {
					$dropdownSelector.empty();
					$dropdownSelector.attr("disabled", true);
				} else {
					var startDateMoment = donation.startDate && window.moment(donation.startDate);
					var startDateOption = startDateMoment ? startDateMoment.format("MM-YYYY") : $dropdownSelector.find("option").eq(0).val();

					var containsOption = false;
					$dropdownSelector.find("option").each((optionIndex, optionItem) => {
						if ($(optionItem).val() === startDateOption) {
							containsOption = true;
							$(optionItem).attr("selected", "selected");
						}
					});

					if (!containsOption) {
						// add option
						var dropdownWizard = ProjectStore.get(WizardConstants.WIZARDS.RECURRING_START_DATE_DROPDOWN_VALUES);
						var formattedMonth = this.getMonthFromWizard(startDateMoment.format("MMMM"), dropdownWizard);
						$dropdownSelector.prepend(`<option value="${startDateOption}" selected="selected">${formattedMonth} ${startDateMoment.format("YYYY")}</option>`);
					}

					$dropdownSelector.val(startDateOption);
				}

				this.initializeRecurringStartDateDropdown($dropdownSelector, "cart", projectId, /* populateInitialValue */ false);
			});
		});
	},

	initializeRecurringStartDateDropdown: function ($dropdown, context, tangibleCode, populateInitialValue) {
		if (populateInitialValue) {
			this.updateRecurringStartDate(context, tangibleCode, /* event */ null, $dropdown);
		}

		$dropdown.off("change.recurringStartDate");
		$dropdown.on("change.recurringStartDate", this.updateRecurringStartDate.bind(this, context, tangibleCode));
	},

	initializeResultRecurringStartDateDropdowns: function ($component, context) {
		// add a listener to each input, on change, write values to store
		var componentContext = context.split("_")[0];
		if (componentContext === "search") {
			componentContext = "searchResults";
		}

		$component.find(`[data-component="${componentContext}.project"] [data-component="recurringStartDateDropdown"]`).each((index, item) => {
			var $dropdownComponent = $(item);
			var $dropdownSelector = $dropdownComponent.find("select");
			var projectCode = $dropdownComponent.attr("data-project-code");

			this.initializeRecurringStartDateDropdown($dropdownSelector, context, projectCode, /* populateInitialValue */ true);
		});
	},

	updateRecurringStartDate: function (context, projectCode, event, $selector) {
		if (event) {
		event.stopPropagation();
		event.preventDefault();
		}

		var $dropdownSelector = $selector || $(event.target);
		var $dropdownComponent = $dropdownSelector.closest("[data-component='recurringStartDateDropdown']");
		var selectedValue = $dropdownSelector.val();
		if (selectedValue == null) {
			selectedValue = $dropdownSelector.find("option").first().val();
		}
		var projectId = $dropdownComponent.attr("data-donation-id");

		if (context === "cart") {
			window.CheckoutActions.updateDonation(projectId, { newStartDate: selectedValue });
		} else {
			Dispatcher.dispatch({
				actionType: ProjectConstants.SET_RECURRING_START_DATE,
				context,
				selectedStartDate: selectedValue,
				tangibleCode: projectCode
			});

			this._updateIsChargeTodayInCheckoutStore(context);
		}

		return false;
	},

	shouldHidePaymentInformation: function() {
		var frequency = ProjectStore.getSelectedFrequency() || ProjectStore.get("defaultPledgeFrequency");

		return {
			hideOneTimeOnlyPayments: !frequency || frequency !== "O",
			hideAllPayments: false
		};
	},

	initializeNonEditableDonations: function () {
		document.addEventListener("DOMContentLoaded", function (event) {
			var $nonEditableProjects = $("[data-component='cart.populated.project'][data-donation-types='nonEditable']");
			$nonEditableProjects.find(":input").prop("disabled", true);
		});
	},

	/**
	 * This method is called when checkout store initializes. It provides a callback method to be used when
	 * this tangible's concept of a total amount has changed. This will let checkout store determine if
	 * payment information should be hidden - in conjunction with shouldHidePaymentInformation().
	 * @param handleTotalChange the callback method to trigger a total amount update.
	 */
	setChangeHandlerMethod: function(handleTotalChange) {
		this._handleTotalChange = handleTotalChange;
	},

	triggerTotalChangedHandler: function() {
		if (_.isFunction(this._handleTotalChange)) {
			this._handleTotalChange();
		}
	},

	_getEventOrReturn: function(event, isDesignModeMessage, preventDefaultInDesignMode) {
		return ActionsHelper.getEventOrReturn(event, ProjectStore.get("isDesignMode"), isDesignModeMessage, preventDefaultInDesignMode);
	},

	_isChargeTodayForOPCO: function() {
		var frequency = ProjectStore.getSelectedFrequency();

		//We charge today if any of these are true
		//	1. Frequency is OneTime
		//	2. The Donation Starts today
		//	3. The Recurring Upsell box is checked
		//	4. Charge Today is configured to always required for Recurring Donations
		//	5. Charge Today is configured to be required for Recurring Donations with a selected Premium
		return frequency === "O" ||
			ProjectStore.donationStartsToday() ||
			ProjectStore.getSelectedUpsell() ||
			ProjectStore.getIsChargeTodayRequired() ||
			(
				ProjectStore.getSelectedPremium() &&
				ProjectStore.getIsChargeTodayRequiredOnlyWithPremium()
			);
	},

	_setRecurringSummaryData() {
		if (ProjectStore.getIsDesignMode()) {
			return;
		}

		var $projectRecurringSummaryElement = $("[data-component='projectRecurringSummary']");
		if (!$projectRecurringSummaryElement.length) {
			//A projectRecurringSummary component does not exist on the page
			return;
		}

		var selectedFrequency = ProjectStore.getSelectedFrequency();
		if (selectedFrequency === "O") {
			//The frequency One-Time, so no recurring
			$projectRecurringSummaryElement.hide();
		} else {
			var $amountElement = $("[data-dynamic='AmountForFrequency'][data-dynamic-property='projectRecurringSummaryProperty']");
			if ($amountElement.length) {
				var total = Number(ProjectStore.getSelectedAmount()) || 0;

				var subaccounts = ProjectStore.getSubaccountAmounts();
				if (subaccounts) {
					//Summing subaccount amounts
					for (var subaccount in subaccounts) {
						total += Number(subaccounts[subaccount]) || 0;
					}
				}

				$amountElement.html(ActionsHelper.formatAmount(total, $amountElement));
			}

			var $frequencyElement = $("[data-dynamic='Frequency'][data-dynamic-property='projectRecurringSummaryProperty']");
			if ($frequencyElement.length) {
				$frequencyElement.text(ProjectStore.getFrequencyDescription(selectedFrequency));
			}

			$projectRecurringSummaryElement.show();
		}
	},

	_updateIsChargeTodayInCheckoutStore: function(context) {
		this._updateIsCheckoutDispatcher(context, {
			actionType: CheckoutConstants.CART_UPDATE_DONATION_CHARGE_TODAY_OPCO,
			isChargeToday: this._isChargeTodayForOPCO()
		});

		DonationUpsellHelper.handleDonationUpsellChange();
	},

	_updateIsCheckoutDispatcher: function(context, dispatchData) {
		if (!context) {
			if (!this._checkoutDispatcher) {
				LoggerInstance.error("We do not have a checkout dispatcher to update.");
				return;
			}

			// We need to trigger a change in the checkout store so that we know the current data for OPCO.
			this._checkoutDispatcher.dispatch(dispatchData);
		}
	},

	setCheckoutDispatcher: function(checkoutDispatcher) {
		this._checkoutDispatcher = checkoutDispatcher;
	},

	getIsSecure: function () {
		return ProjectStore.getIsSecure();
	},

	setIsSecure: function(isSecure) {
		ProjectStore.setIsSecure(isSecure);
	},

	setSecureProjectsWizard: function (secureProjectsWizard) {
		secureProjectsWizard = secureProjectsWizard || {};
		ProjectStore.setSecureProjectsWizard(secureProjectsWizard);
	},

	getProjectDispatcher: function() {
		return ProjectStore.getProjectDispatcher();
	},

	_shouldShowPaymentTerms: function () {
		var deferred = new $.Deferred();

		if (!ProjectStore.getArePaymentTermsConfigured()) {
			deferred.resolve(false);
			return deferred;
		}

		PaymentTermsHelper.arePaymentTermsConfigured().done(arePaymentTermsConfigured => {
			if (!arePaymentTermsConfigured) {
				deferred.resolve(false);
			}

			var frequency = ProjectStore.getSelectedFrequency();
			deferred.resolve(frequency != "O");
		}).fail(() => {
			deferred.resolve(false);
		});

		return deferred;
	}
};

module.exports = ProjectActions;
